import { render } from "./DemoDataVersion100.vue?vue&type=template&id=71d841c1&scoped=true"
import script from "./DemoDataVersion100.vue?vue&type=script&lang=js"
export * from "./DemoDataVersion100.vue?vue&type=script&lang=js"

import "./DemoDataVersion100.vue?vue&type=style&index=0&id=71d841c1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d841c1"]])

export default __exports__